import { selectTab } from "./tab";
// webpack のモジュールを html の onClick などで動的に呼び出すため、グローバルに格納できるようにする
interface Window {
  selectTab(id: number): void;
}
declare var window: Window;

// html が読み込まれてからグローバルに関数を設定
document.addEventListener("DOMContentLoaded", _event => {
  window.selectTab = selectTab;
});
